import { isSameDavUrl } from 'libs/dav/davPath'
import type { TodoFolder } from '../../modules/TodoFolder'

/**
 * defaultDueDate 설정값에 따라 기본 마감일을 반환한다.
 */
export function getDefaultDueDate(defaultDueDateSetting: string): Date | null {
  if (!defaultDueDateSetting || defaultDueDateSetting === 'no-date') {
    return null
  }

  const today = new Date()
  today.setHours(0, 0, 0, 0)

  switch (defaultDueDateSetting) {
    case 'today':
      return today
    case 'tomorrow': {
      const tomorrow = new Date(today)
      tomorrow.setDate(today.getDate() + 1)
      return tomorrow
    }
    default:
      return null
  }
}

export const getDefaultFolder = (
  defaultFolder: string | null,
  lastAddedFolder: string | null,
  folders: TodoFolder[],
): TodoFolder | undefined => {
  if (defaultFolder) {
    // defaultFolder 는 settings 에 저장된 path(구버전은 절대 URL) 이므로 host 를 무시하고 비교한다.
    return folders.find((f) => isSameDavUrl(f.url, defaultFolder))
  }

  const writeFolders = folders.filter((f) => !f.isReadOnly)

  if (lastAddedFolder) {
    return writeFolders.find((f) => isSameDavUrl(f.url, lastAddedFolder))
  }

  const folder = writeFolders.find((f) => f.isDefault === true)

  return folder || folders[0]
}
